import React from 'react'

import Dashboard from './dashboard'
import Calendar from './calendar'
import Event from './event/show'

import { Switch, Route, Redirect } from 'react-router-dom'

import { LAYOUT_MANAGER_HOME_CALENDAR, LAYOUT_MANAGER_HOME_EVENT, LAYOUT_MANAGER_HOME_DASHBOARD } from '../navigation'

const Router = (props) => (
  <Switch>
    <Route path={LAYOUT_MANAGER_HOME_DASHBOARD} render={(routeProps) => <Dashboard {...props} {...routeProps} />} />
    <Route path={LAYOUT_MANAGER_HOME_EVENT}>
      <Event />
    </Route>
    <Route path={LAYOUT_MANAGER_HOME_CALENDAR}>
      <Calendar />
    </Route>
    <Redirect to={LAYOUT_MANAGER_HOME_DASHBOARD} />
  </Switch>
)

export default Router
